export function removeNaNAndEmpty(value: string): string {
    value = value.replace(/[^0-9]/g, '');
    value = value.replace(/\s/g, '');
    return value;
}

export function formatMonth(month: string): string {
    month = removeNaNAndEmpty(month);
    if (month.length < 2) {
        month = '0' + month;
    }
    return month;
}

export function formatYear(year: string): string {
    year = removeNaNAndEmpty(year);
    if (year.length > 2) {
        year = year.slice(-2);
    }

    return year;
}

export function formatLongYear(year: string): string {
    year = removeNaNAndEmpty(year);
    if (year.length == 2) {
        year = '20' + year;
    }

    return year;
}
